export default {
    newPageCreateFile: "Criando ficheiro",
    globalConfirm: "OK",
    globalCancel: "Cancelar",
    globalStyle: "Estilo",
    globalColor: "Cor",
    globalLine: "Linha",
};
